<template>
  <div class="app">
    <nav class="menu">
      <div class="content">
        <img src="../assets/logo.png"/>
        <span class="name">易学起名大师</span>
      </div>
    </nav>
    <div class="container">
      <div class="main-wrapper index">
        <div class="main index">
          <div class="index-content">
            <div class="title"><div><span>易学起名大师</span></div><span class="subfix">专业的起名APP</span></div>
            <div class="sub-title">
              
              <span class="phone">手机版用户可以扫描下方二维码便捷进入或下载易学起名大师APP</span>
              <span class="h5">手机端可以登录App Store、应用宝、小米商店、华为商店和ViVo商店下载</span>
            </div>
          </div>
          <div class="video"><img src="../assets/video.png"/></div>
        </div>
        <div class="app">
          <div class="ddd">
            <img src="../assets/pingguo.png" class="icon"/><span>苹果手机扫码下载</span>
            <div class="qrcode">
              <img src="../assets/ios-download.png"/>
            </div>
          </div>
          <div class="ddd">
            <img src="../assets/android.png" class="icon"/><span>安卓手机扫码下载</span>
            <div class="qrcode">
              <img src="../assets/android-download.png"/>
            </div>
        </div>
      </div>
      </div>
      <div class="main-wrapper demo" style="margin-top: 30px;">
        <div class="main">
          <h3>界面演示</h3>
          <div class="lists">
            <div class="item">
              <img src="../assets/1.jpeg"/>
            </div>
            <div class="item">
              <img src="../assets/2.jpeg"/>
            </div>
            <div class="item">
              <img src="../assets/3.jpeg"/>
            </div>
            <div class="item">
              <img src="../assets/4.jpeg"/>
            </div>
            <div class="item">
              <img src="../assets/5.jpeg"/>
            </div>
            <div class="item">
              <img src="../assets/6.jpeg"/>
            </div>
          </div>
        </div>
      </div>
      <div class="main-wrapper footer">
        <div class="main" style="font-weight:normal">
          Copyright &COPY; 2024 易学起名大师 <a href="https://beian.miit.gov.cn" style="color:#fff;text-decoration: none;">沪ICP备2024055314号-2</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import yaml from 'js-yaml'
import axios from 'axios'
export default {
  name: 'app',
  data() {
    return {
      showios: false,
      showand: false,
      download: '',
      config: '',
      text: '点击下载Windows客户端 (64位)',
      visible: false,
      cvisible: false
    };
  },
  methods: {
    showcode(key) {
      if (key === 'ios') {
        this.showios = true
      } else {
        this.showand = true
      }
    },
    hidecode(key) {
      if (key === 'ios') {
        this.showios = false
      }else{
        this.showand = false
      }
    },
    async getPosType() {
      var agent = navigator.userAgent.toLowerCase();
      var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
      if (agent.indexOf("win32") >= 0 || agent.indexOf("wow32") >= 0) {
          const yml = await this.loadFile('https://xfsc.firepal.cn/update/win32/ia32/latest.yml')
          const config = yaml.load(yml)
          this.download = 'https://xfsc.firepal.cn/update/win32/ia32/' + config.files[0].url
          this.text = '点击下载Windows客户端 (32位)'
      }
      if (agent.indexOf("win64") >= 0 || agent.indexOf("wow64") >= 0) {
          const yml = await this.loadFile('https://xfsc.firepal.cn/update/win32/x64/latest.yml')
          const config = yaml.load(yml)
          this.download = 'https://xfsc.firepal.cn/update/win32/x64/' + config.files[0].url
          this.text = '点击下载Windows客户端 (64位)'
      }
      if (isMac) {
          const yml = await this.loadFile('https://xfsc.firepal.cn/update/darwin/latest-mac.yml')
          const config = yaml.load(yml)
          this.download = 'https://xfsc.firepal.cn/update/darwin/' + config.files[1].url
          this.text = '点击下载Mac客户端'
      }
    },
    async loadFile(url) {
      return await axios.get(url, {
        withCredentials: false,
      }).then(res => res.data)
    },
    downloadClient(){
      location.href = this.download
    }
  },
  mounted() {
    this.getPosType()
  }
};
</script>

<style lang="less">
@font-face {
	  font-family: 'Truth';
	  src: url('../assets/fonts/truth.woff') format('woff'), url('../assets/fonts/truth.otf') format('otf'), url('../assets/fonts/truth.ttf') format('opentype');
	  font-style: normal;
	  font-weight: normal;
	}
html,
body {
  margin: 0;
  padding: 0;
  /* height: 100%; */
  width: 100%;
  /* overflow: hidden; */
  font-family: "microsoft yahei", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fff;
}
.app {
  /* height: 100%; */
  width: 100%;
}
p {
  /* margin: 0; */
  /* text-align: center; */
  /* width: 800px; */
  margin: 0 auto;
}
h1,h3,h4,h2,h5{
  padding: 0;
  margin: 0;
}
h3{
  font-size: 36px;
  margin-bottom: 20px;
  font-family: 'Truth';
  font-weight: normal;
}
html,
body,
#app {
  height: 100%;
  margin: 0;
  padding: 0;
}
.container{
  width: 100%;
}
.menu{
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  background: rgba(255, 255, 255, 0.3);
  .content{
    width: 1200px;
    margin: 0 auto;
    color: #fff;
    display: flex;
    align-items: center;
    padding: 15px 0;
    font-size: 24px;
    // justify-content: space-between;
    img{
      width: 48px;
      height: 48px;
      margin-right: 20px ;
      border-radius: 10px;
    }
    .name{
      color: #295F5E;
      font-size: 20px;
      // font-weight: 800;
      font-family: 'Truth';
    }
  }
  .right-menu{
    font-size: 16px;
    color: #333;
    cursor: pointer;
    font-weight: 500;
    margin-left: auto;
  }
  .free{
    margin-right: 30px;
    color: #295F5E;
    position: relative;
    &::before{
      content: '免费';
      font-size: 6px;
      position: absolute;
      right: -20px;
      top: -15px;
      background-color: #CE5653;
      color: #fff;
      padding: 0 5px;
      border-radius: 10px;
    }
  }
}

.main{
  width: 1200px;
  margin: 0 auto;
  text-align: center;
  /* display: inline-block; */
  &.index{
    margin-top: 150px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    justify-content: space-between;
    h1{
      font-size: 48px;
    }
    h4{
      font-size: 36px;
      font-weight: 400;
      margin-top: 20px;
      margin-bottom: 50px;
    }
    .video{
      width: 495px;
      height: 285px;
      background: #f1f1f1;
      img{
        width: 495px;
        height: 285px;
      }
    }
    
  }
  &.resume{
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.button-code{
  width: 190px;
  height: 50px;
  border-radius: 50px;
  background: #fff;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  color: #333;
  cursor: pointer;
  img{
    width: 20px;
    height: 22px;
    margin-right: 20px;
  }
}
.index-phone {
  display: inline-block;
  img{
    width: 264px;
    margin-right: 150px;
  }
}
.index-content{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .title{
    font-size: 54px;
    // font-weight: 800;
    font-family: 'Truth';
    color: #333;
    display: flex;
    align-items: flex-end;
    div{
      
      span:first-child{
        color: #CE5653;
        font-family: 'Truth';
        font-size: 54px;
      }
    }
    
    .subfix{
      font-family: 'Truth';
      font-size: 26px;
      margin-left: 20px;
    }
  }
  .sub-title{
    margin-top: 20px;
    font-size: 14px;
    color: #333;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: 60px;
    justify-content: space-between;
    i{
      color: #CE5653;
      font-style: normal;
    }
    .h5{
      display: none;
    }
    span{
      position: relative;
      padding-left: 20px;
      &::before{
        position: absolute;
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-bottom: 6px solid #333;
        font-size: 0;
        line-height: 0;
        transform: rotate(90deg);
        display: inline-block;
        content: "";
        left: 0;
        top: 50%;
        margin-top: -3px;
      }
    }
  }
}
.buttons{
  .pc{
    display: flex;
    align-items: center;
    width: 500px;
    background: #295F5E;
    border-radius: 50px;
    justify-content: center;
    height: 44px;
    cursor: pointer;
    margin-top: 50px;
    img{
      height: 20px;
      margin-right: 10px;
    }
  }
  
}
.main-wrapper{
  width: 100%;
  display: inline-block;
  &.index{
    height: 750px;
    background: url('../assets/bgggg.png');
    background-size: 100% auto;
    .app{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      width: 1200px;
      margin: 60px auto 50px auto;
      .ddd{
        display: flex;
        align-items: center;
        
        width: 240px;
        background: #295F5E;
        border-radius: 50px;
        justify-content: center;
        height: 44px;
        cursor: pointer;
        position: relative;
        .icon{
          height: 20px;
          margin-right: 10px;
        }
        .qrcode{
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          top: 70px;
          box-sizing: border-box;
          border: 5px solid #fff;
          background-color: #fff;
          border-radius: 5px;
          &::before{
            width: 0;
            height: 0;
            border-bottom: 10px solid #fff;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
            font-size: 0;
            line-height: 0;
            top: -14px;
            left: 50%;
            transform: translateX(-50%);
            display: inline-block;
            content: "";
            position: absolute;
            z-index: 9999;
          }
          img{
            width: 120px;
          }
        }
      }
    }
  }
  &.jobs{
    background: #fff;
    text-align: center;
    color: #333;
    padding-top: 50px;
  }
  &.resume {
    /* width: 100%; */
    position: relative;
    margin-top: 50px;
    text-align: center;
    color: #333;
    img{
      width: 800px;
      padding: 100px 0 50px;
    }
    &::before{
      width: 140%;height: 780px;
    }
    h3{
      margin-top: 50px;
    }
  }
  &.many{
    text-align: center;
    color: #333;
    padding: 50px 0;
    img{
      width: 1000px;
      margin-top: 80px;
    }
  }
  &.demo{
    h3{
      color: #333;
    }
    .lists{
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: space-evenly;
      margin-top: 50px;
      .item{
        margin-bottom: 40px;
      }
      img{
        width:375px;
        height: 800px;
        border-radius: 28px;
      }
    }
  }
  &.footer{
    background: #34363E;
    padding: 32px 0;
    text-align: center;
  }
}
.popup{
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.6);
  .p-body{
    position: absolute;
    width: 600px;
    height: 500px;
    background: #fff;
    color: #333;
    box-sizing: border-box;
    padding: 20px;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
  }
  .p-title{
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 20px;
    span{
      position: absolute;
      top: 20px;
      right: 20px;
      font-size: 30px;
      font-weight: 100;
      cursor: pointer;
      padding: 0 5px;
    }
  }
  p{
    line-height: 2;
    &.q{
      font-weight: 500;
      margin: 10px 0;
    }
    &.a{
      color: #666;

      font-size: 14px;
    }
  }
}
.items{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 50px;
  .item{
    width: 254px;
    text-align: center;
    display: flex;
    height: 182px;
    overflow: hidden;
    margin-bottom: 60px;
    img{
      width: 100%;
      height: 182px;
    }
    &:last-child{
      width: 569px;
    }
  }
}
.mutil{
  // margin-top: 80px;
  padding: 40px 0;
  // background: linear-gradient(90deg, rgba(29, 97, 232,0.3), rgba(211, 230, 252,0.3));
  color: #333;
  background: url('../assets/mutilbg.png') no-repeat;
  background-size: 100% auto;
}
.hezuo{
  color: #333;
  margin-top: 80px;
  margin-bottom: 80px;
  span{
    color: #CE5653;
  }
  .lists{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 1200px;
    margin: 0 auto;
    justify-content: space-between;
    margin-top: 40px;
    div{
      width: 240px;
      height: 240px;
      background: #fcfcfc;
      display: flex;
      align-items: center;
      justify-content: center;
      border-right: 1px solid #f4f4f4;
      border-bottom: 1px solid #f4f4f4;
      box-sizing: border-box;
      &:hover{
        background: rgba(55, 111, 246, 0.3);
      }
    }
    img{
      width: 120px;
      height: 120px;
      border-radius: 120px;
    }
  }
}
.color{
  color:#CE5653 ;
}
@media screen and (max-width: 768px) {
  .menu{
    .content{
      padding: 15px 20px;
      width: 100%;
      box-sizing: border-box;
    }
    .right-menu{
      display: none;
    }
  }
  .index-content{
    .title{
      font-size: 30px;
      // flex-direction: column;
      align-items: flex-end;
      div{      
        span:first-child{
          color: #CE5653;
          font-family: 'Truth';
          font-size: 30px;
        }
      }
      .subfix{
        // margin-left: 0;
        font-size: 17px;
        // margin-top: 10px;
      }
    }
  }
  .sub-title{
    .pc,.phone{
      display: none;
    }
    span::before{
      top:8px !important;
      margin-top: 0 !important;
    }
  }
  .h5{
      display: inline-block !important;
      margin-bottom: 5px;
    }
  .buttons{
    display: none;
  }
  .main.index{
    flex-direction: column;
    width: 100%;
    margin-top: 100px;
    box-sizing: border-box;
    padding: 0 20px;
    justify-content: center;
    .video {
      width: 100%;
      height: auto;
      margin-top: 40px;
      img{
        width: 100%;
        height: auto;
      }
    }
  }
  .main-wrapper.index{
    background-repeat: no-repeat;
    background-size: auto 100%;
    height: 520px;
    .app{
      display: none;
    }
  }
  .main-wrapper.jobs{
    display: none;
  }
  .main{
    width: 100%;
  }
  .hezuo{
    margin-top: 40px;
    margin-bottom: 40px;
    p{
      padding: 0 20px;
      box-sizing: border-box;
    }
  }
  .hezuo .lists{
    width:100%;
    justify-content: center;
    div{
      width: 50%;
    }
  }
  .main-wrapper.demo {
    .lists{
      box-sizing: border-box;
      padding: 0 20px;
      .item{
        margin-bottom: 20px;
      }
      img{
        width:100%;
        height: auto;
      }
    }
  }
  .main-wrapper.footer{
    font-size: 14px;
  }
  .mutil{
    background-size: auto 100%;
    p{
      padding: 0 20px;
      box-sizing: border-box;
    }
  }
  h3{
    font-size: 28px;
  }
  p,span{
    text-align: left;
  }
}
</style>
